<main
  [style]="
    data.theme === 'dark'
      ? 'background-color: #373534; color: #ffffff'
      : 'background-color: #F7F7F7; color: black'
  "
>
  <mat-dialog-content>
    <div class="d-flex flex-column gap-2 text-black">
      <div class="d-flex justify-content-between mb-2">
        <span class="lead fw-bold">{{ 'legalInformation' | i18next }}</span>
        <span mat-dialog-close>
          <mat-icon>close</mat-icon>
        </span>
      </div>
      <span class="fw-bold">{{ 'note' | i18next }}</span>
      <p class="text-muted mb-2">{{ 'legalNote' | i18next }}</p>
      <span class="fw-bold">{{ 'penaltyAccident' | i18next }}</span>
      <p class="text-muted mb-2">
        {{ 'penaltyAccidentDescription' | i18next }}
      </p>
      <ul class="text-muted mb-2">
        <li *ngFor="let increase of penaltyAccidentIncreases">
          {{ increase | i18next }}
        </li>
      </ul>
      <span class="text-muted">{{ 'penaltyAccidentNote' | i18next }}</span>
    </div>
  </mat-dialog-content>
</main>
